import posthog from "posthog-js";
import {
  wireGlobalErrorListeners,
  beforeSend,
} from "@soprisapps/components/utils/errorReporting";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  ui_host: "https://us.posthog.com",
  debug: process.env.NEXT_PUBLIC_APP_ENV === "dev",
  autocapture: true,
  capture_pageview: true,
  capture_pageleave: true,
  person_profiles: "always",
  disable_session_recording: false,
  enable_recording_console_log: true,
  session_recording: {
    maskAllInputs: true,
  },
  before_send: beforeSend,
});

posthog.register({
  environment: process.env.NEXT_PUBLIC_APP_ENV,
  app_context: process.env.NEXT_PUBLIC_APP_CTX,
  hostname: window.location.hostname,
  code_version: process.env.NEXT_PUBLIC_REACT_FRONTEND_VERSION,
});

wireGlobalErrorListeners();
